import { render } from "./tutorialDialog.vue?vue&type=template&id=3ff7ae84&scoped=true"
import script from "./tutorialDialog.vue?vue&type=script&lang=js"
export * from "./tutorialDialog.vue?vue&type=script&lang=js"

import "./tutorialDialog.vue?vue&type=style&index=0&id=3ff7ae84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff7ae84"]])

export default __exports__